// ------ action constants

export const ACTION_AUTH_SUCCESSFUL = 'ACTION_AUTH_SUCCESSFUL';
